// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".validation_error_text{font-size:14px;color:orangered;margin:0;position:relative;top:-1rem}.decimal-list{list-style:decimal !important;margin:0}.css-g1d714-ValueContainer{padding:2px 0px !important}.flex-column label{padding:0px !important}.roleForm .input-field input{margin-bottom:0}.formRow{margin-top:10px}.multiselectView{max-height:200px;overflow-y:auto}\n", ""]);
// Exports
module.exports = exports;
